import { render, staticRenderFns } from "./liveCall.vue?vue&type=template&id=eb491372&"
import script from "./liveCall.vue?vue&type=script&lang=js&"
export * from "./liveCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports